import React from 'react'

const data = [
    {
        id: 0,
        name: 'What is Virtual Reality?',
        img: 'http://dev.imbibe.info/images/vr_what-is-vr/grid.jpg',
        url: '/digital-realities/what-is-vr',
        slideshow: [
            'http://dev.imbibe.info/images/vr_what-is-vr/01.jpg',
            'http://dev.imbibe.info/images/vr_what-is-vr/02.jpg',
            'http://dev.imbibe.info/images/vr_what-is-vr/03.jpg',
            'http://dev.imbibe.info/images/vr_what-is-vr/04.jpg',
        ]
    },
    {
        id: 1,
        name: 'What is Augmented Reality?',
        img: 'http://dev.imbibe.info/images/ar_what-is-ar/grid.jpg',
        url: '/digital-realities/what-is-ar',
        slideshow: [
            'http://dev.imbibe.info/images/ar_what-is-ar/01.jpg',
            'http://dev.imbibe.info/images/ar_what-is-ar/02.jpg',
        ]
    },
    {
        id: 2,
        name: '250 Williams Street',
        img: 'http://dev.imbibe.info/images/vr_250-williams/grid.jpg',
        hero: 'http://dev.imbibe.info/images/vr_250-williams/hero.jpg',
        url: '/digital-realities/vr_250-williams',
        scope: [
            'Modeling of building',
            'Conception of improvements',
            'Modeling improvements',
            'Virtual reality implementation via HTC Vive',
        ],
        copy: 'Imbibe was hired by Cushman & Wakefield to build the 1 million sq. ft. John Portman office building in Downtown Atlanta in Virtual Reality. As part of the sales strategy Imbibe concepted, designed and built spacial improvement to the building and created a VR experience in which the user could switch from the current building to the future building.',
        video: 'https://youtu.be/sHAfNIwYSsY',
    },
    {
        id: 3,
        name: 'Colony Square VR Experience',
        img: 'http://dev.imbibe.info/images/vr_colony-square/grid.jpg',
        hero: 'http://dev.imbibe.info/images/vr_colony-square/hero.jpg',
        url: '/digital-realities/vr_colony-square',
        scope: [
            'Modeling and animation of various components',
            'Virtual reality implementation via HTC Vive',
            'Augmented reality implementation via MS Hololens and Tango',
        ],
        copy: 'Imbibe created a VR experience for North American Properties to articulate the vision for their transformative redesign of an Atlanta iconic mixed use property. We took the model from the architect and created a VR experience in which the user can explore the entire property. This experience is used as a sales tool in the leasing office for prospective tenants.',
        video: 'https://youtu.be/Cov3lZExlq0',
    },
    {
        id: 4,
        name: 'Atlanta Financial Center',
        img: 'http://dev.imbibe.info/images/vr_atlanta-financial-center/grid.jpg',
        hero: 'http://dev.imbibe.info/images/vr_atlanta-financial-center/hero.jpg',
        url: '/digital-realities/vr_atlanta-financial-center',
        scope: [
            'Modeling of building',
            'Conception of improvements',
            'Modeling improvements',
            'Virtual reality implementation via HTC Vive',
        ],
        copy: 'Imbibe was asked by CBRE to create a virtual reality experience for a lobby renovation. We concepted, designed and built the environment and partnered with Site Solutions to envision the exterior courtyard.',
        video: 'https://youtu.be/u8dPpAAtJjI',
    },
    {
        id: 5,
        name: 'The Hotel at Avalon',
        img: 'http://dev.imbibe.info/images/vr_hotel-avalon/grid.jpg',
        hero: 'http://dev.imbibe.info/images/vr_hotel-avalon/hero.jpg',
        url: '/digital-realities/vr_hotel-avalon',
        scope: [
            'Modeling of all public spaces, furnishings and finishes',
            'Virtual reality implementation via HTC Vive',
            'Promotional video',
        ],
        copy: 'Imbibe was engaged to help Stormont Hotel Group create a virtual reality experience to allow users a look into what their upcoming hotel would look like. We modeled all the public spaces, bar and restaurant as well as the pool deck. The experience is used to solicit bookings in conjunction with the Alpharetta Conference Center prior to opening of the hotel in January 2018.',
        video: 'https://youtu.be/tPSAJnBWKko',
    },
    {
        id: 6,
        name: 'Alpharetta Conference Center',
        img: 'http://dev.imbibe.info/images/vr_alpharetta-conference-center/grid.jpg',
        hero: 'http://dev.imbibe.info/images/vr_alpharetta-conference-center/hero.jpg',
        url: '/digital-realities/vr_alpharetta-conference-center',
        scope: [
            'Modeling of the space and various function layouts',
            'Interactive menu to choose various layouts',
            'Virtual reality implementation via HTC Vive',
            'Promotional video',
        ],
        copy: 'In order to showcase the Alpharetta Conference Center and solicit bookings prior to opening in January 2018 the Alpharetta Convention and Visitor Bureau engage Imbibe to visualize the 44,000 sqft. Facility. We modeled the space and articulated various uses including ballroom set-up, trade show environment and seminars. The users are able to visualize their uses for the space prior to construction completion.',
        video: 'https://youtu.be/wZgRyw-BczA',
    },
    {
        id: 7,
        name: 'AC Hotels Living Walls Experience',
        img: 'http://dev.imbibe.info/images/vr_ac-hotel/grid.jpg',
        hero: 'http://dev.imbibe.info/images/vr_ac-hotel/hero.jpg',
        url: '/digital-realities/vr_ac-hotel',
        scope: [
            '4k 360 video capture of all artworks',
            'Creation of mobile VR experience using Samsung GearVR',
        ],
        copy: 'As part of the VIP Grand Opening of their newest hotel in Downtown Atlanta AC Hotels engaged Imbibe to create a virtual reality experience for their guests. Showcasing the murals created by the Living Walls group around the downtown area Imbibe created a virtual tour of the most prominent ones capturing the artworks in 360 video. Guest at the VIP event were able to see all the artwork surrounding the area of the hotel in 4k 360 video.',
        video: '',
    },
    {
        id: 8,
        name: 'Colony Square AR Experience',
        img: 'http://dev.imbibe.info/images/ar_colony-square/grid.jpg',
        hero: 'http://dev.imbibe.info/images/ar_colony-square/hero.jpg',
        url: '/digital-realities/ar_colony-square',
        scope: [
            'Modeling and animation of various components',
            'Augmented reality implementation via MS Hololens, smartphone and tablet',
        ],
        copy: 'Imbibe created an AR experience for North American Properties to articulate the vision for their transformative redesign of an Atlanta iconic mixed use property. We took the model from the architect and created an AR experience in which the user can explore the entire property. This experience is used as a sales tool in the leasing office for prospective tenants.',
        video: 'https://youtu.be/LwF9DGV_C4Q',
    },
];

export default data;


// WEBPACK FOOTER //
// ./src/data/digital-realities.js